'use client';

import { Button } from '@workspace/ui/components/button';
import { Icon } from '../ui/Icon';
import { TooltipComponent } from './TooltipComponent';
import { useProfileUIStore } from '@/src/sections/profile/store/profile-ui-store';
import { cn } from '@workspace/ui/lib/utils';

export const PreviewModeSections = () => {
  const setMobileView = useProfileUIStore(state => state.setMobileView);
  const isMobileView = useProfileUIStore(state => state.isMobileView);
  const togglePreviewMode = useProfileUIStore(state => state.togglePreviewMode);
  const isPreviewMode = useProfileUIStore(state => state.previewMode);

  return (
    <div className="flex gap-2">
      <TooltipComponent text="Switch to editor mode">
        <Button
          size="sm"
          variant="ghost"
          className="cursor-pointer px-3.5 py-2.5"
          onClick={() => {
            togglePreviewMode();
            setMobileView(false);
          }}
        >
          <Icon
            name={isPreviewMode ? 'edit' : 'eye'}
            width={20}
            className="w-5 h-3.5 text-black"
          />
        </Button>
      </TooltipComponent>
      <TooltipComponent text="Desktop preview">
        <Button
          size="sm"
          variant={isMobileView ? 'ghost' : 'secondary'}
          className={cn('cursor-pointer px-3.5 py-2.5 md:flex hidden', {
            'bg-black': !isMobileView,
            'text-white': !isMobileView,
          })}
          onClick={() => setMobileView(false)}
        >
          <Icon
            name="desktop-view"
            width={20}
            className={cn('w-5 h-3.5 text-black', {
              'text-white': !isMobileView,
            })}
          />
        </Button>
      </TooltipComponent>
      <TooltipComponent text="Mobile preview">
        <Button
          size="sm"
          variant={!isMobileView ? 'ghost' : 'secondary'}
          className={cn('cursor-pointer px-3.5 py-2.5', {
            'bg-black': isMobileView,
          })}
          onClick={() => setMobileView(true)}
        >
          <Icon
            name="mobile-view"
            width={20}
            className={cn('w-5 h-3.5 text-black', {
              'text-white': isMobileView,
            })}
          />
        </Button>
      </TooltipComponent>
    </div>
  );
};
